




















































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class NotFound extends Vue {
  get message() {
    return '404 此页面不存在'
  }
}
